export const removeObjectWithId = (arr, id) => {
    return arr.filter((obj) => obj.id !== id);
  }